import elementResizeDetectorMaker from 'element-resize-detector';
import debounce from 'lodash/debounce';
import React from 'react';

const DEBOUNCE_DELAY_MS = 50;

const withRootResizeDetection = (WrappedComponent) => {
    return class PopupHOC extends React.Component {
        constructor(props) {
            super(props);

            this.root = document.getElementById('react-root');
            this.erd = elementResizeDetectorMaker({
                strategy: 'scroll',
            });
        }

        componentDidMount() {
            this.erd.listenTo(
                this.root,
                debounce(() => this.forceUpdate(), DEBOUNCE_DELAY_MS)
            );
        }

        componentWillUnmount() {
            this.erd.uninstall(this.root);
        }

        render() {
            return <WrappedComponent {...this.props} rootNode={this.root} />;
        }
    };
};

export default withRootResizeDetection;
